import { FormControl, FormHelperText, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { FC } from "react";
import useTranslateMessage from "../../hooks/useTranslateMessage";

interface Props {
  value: string[];
  error?: string;
  onBlur: () => void;
  onChange: (newValue: string[]) => void;
}

const ChipInput: FC<Props> = ({ value: chips, error, onBlur, onChange }) => {
  const t = useTranslateMessage();

  return (
    <FormControl error={!!error}>
      <Autocomplete
        multiple
        freeSolo
        options={[]}
        value={chips}
        onChange={(_event, newValue) => onChange(newValue as string[])}
        onBlur={onBlur}
        renderInput={(params) => (
          <TextField
            {...params}
            error={!!error}
            placeholder={t({ id: "chipInputPlaceHolder" })}
          />
        )}
      />
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

export { ChipInput };
